'use client';
import styled from 'styled-components';
import { colors, toRgba } from '@/styles';

export const Cell = styled.div``;

export const StatusIndicator = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  height: 20px;
  width: 20px;
  aspect-ratio: 1;
  border-radius: 4px;
  background-color: ${colors.secondary.lightGray3};
  color: ${colors.primary.black};

  &.added {
    background-color: ${toRgba(colors.semantic.diff.added.indicator, 0.15)};
    color: ${colors.semantic.diff.added.indicator};
  }
  &.removed,
  &.deleted {
    background-color: ${toRgba(colors.semantic.diff.removed.indicator, 0.15)};
    color: ${colors.semantic.diff.removed.indicator};
  }
  &.modified {
    background-color: ${toRgba(colors.semantic.diff.modified.indicator, 0.15)};
    /* color: ${colors.semantic.diff.modified.indicator}; */
  }
`;
